import { useState } from "react";
import { motion } from "framer-motion";
import { List, X } from "@phosphor-icons/react";

const links = [
  { label: "Serviços", href: "#servicos", testid: "nav-link-services" },
  { label: "Diferencial", href: "#diferencial", testid: "nav-link-differential" },
  { label: "Depoimentos", href: "#depoimentos", testid: "nav-link-testimonials" },
  { label: "Contato", href: "#contato", testid: "nav-link-contact" },
];

export const Logo = ({ dark = false }) => (
  <a href="#top" data-testid="logo-link" className="flex items-center gap-3 group">
    <img
      src={dark ? "/assets/icon-white.png" : "/assets/icon-gold.png"}
      alt="Símbolo Kordeiro"
      className="h-11 w-auto transition-transform duration-300 group-hover:rotate-[-4deg]"
    />
    <span className={`font-display font-extrabold tracking-tight text-lg leading-none ${dark ? "text-[#FAFAFA]" : "text-ink"}`}>
      KORDEIRO
      <span className="block text-[10px] font-body font-semibold tracking-[0.35em] text-gold-dark">MSP</span>
    </span>
  </a>
);

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className="fixed top-0 inset-x-0 z-40 bg-white/70 backdrop-blur-xl border-b border-black/5"
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-10" data-testid="nav-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm font-medium text-neutral-600 hover:text-ink transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="#contato"
            data-testid="nav-cta-button"
            className="hidden sm:inline-flex items-center gap-2 bg-ink text-[#FAFAFA] text-sm font-semibold px-5 py-2.5 rounded-sm hover:bg-gold hover:text-ink transition-colors duration-300"
          >
            Solicitar orçamento
          </a>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="md:hidden p-2 text-ink"
            aria-label="Abrir menu"
          >
            {open ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden bg-white border-t border-black/5 px-6 py-6 flex flex-col gap-5" data-testid="nav-mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.testid}-mobile`}
              onClick={() => setOpen(false)}
              className="text-base font-semibold text-ink"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contato"
            data-testid="nav-cta-button-mobile"
            onClick={() => setOpen(false)}
            className="inline-flex justify-center bg-ink text-[#FAFAFA] text-sm font-semibold px-5 py-3 rounded-sm"
          >
            Solicitar orçamento
          </a>
        </div>
      )}
    </motion.header>
  );
}
